import { RootState } from '@/store/stores'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import programApi from '@/api/operations/programApi'

import { initialState } from '@store/types/globalExclusionTimeType'

export const fetchGlobalExclusionTime = createAsyncThunk(
  'globalExclusionTime/fetchGlobalExclusionTime',
  async (interfaceId: number, { rejectWithValue }) => {
    try {
      const { data } = await programApi.getGlobalExclusion(interfaceId)

      return {
        interfaceId,
        globalExclusionTimeData: data,
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const globalExclusionTimeSlice = createSlice({
  name: 'globalExclusionTime',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGlobalExclusionTime.fulfilled, (state, action) => {
        if (action.payload.globalExclusionTimeData && action.payload.interfaceId) {
          state.globalExclusionTimeData[`${action.payload.interfaceId}`] =
            action.payload.globalExclusionTimeData
        }
      })
  },
})

export const globalExclusionTimeState = (state: RootState) =>
  state.globalExclusionTime

export const selectGlobalExclusionTimeByInterface = (interfaceId: number) => (state: RootState) =>
  state.globalExclusionTime.globalExclusionTimeData[`${interfaceId}`] || []

export default globalExclusionTimeSlice.reducer